export default __webpack_public_path__ + "static/apple_logo-87f0c18ab3a4de45c4b7f8718883bbda.png";